/**
 * Trade page: hides the Shopify Forms embed's own heading and description.
 *
 * The page already carries live's "Wholesale Registration Form" h1 and intro above the form,
 * so the app's "Trade Registration Form" header read as a second title. The app renders into
 * an open shadow root with no ::part hooks and no setting for the header, so the only way in
 * from the theme is a style element inside that root. It is re-added if the app re-renders.
 *
 * Should the class hash change in an app update, the selector simply stops matching and the
 * header shows again - the form itself is never touched.
 */
(() => {
  const STYLE_ID = 'orl-trade-form-style';
  /* The embed's own rules live in adopted stylesheets, which cascade after a <style> element in
     the same root - so anything overriding them needs the higher specificity used below.
     The outer container is a grid centred on its content; on a phone that shrank the form to
     212px inside a 358px column. Stretching it lets the form take the column, up to its own
     max-width. */
  const CSS = `
    [class*="_formHeader_"] { display: none; }
    div[class*="_container_"][class*="_container_"] { justify-content: stretch; }
  `;

  const apply = (root) => {
    if (root.getElementById(STYLE_ID)) return;

    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = CSS;
    root.appendChild(style);
  };

  const watch = (host) => {
    const root = host.shadowRoot;
    if (!root) return false;

    apply(root);
    new MutationObserver(() => apply(root)).observe(root, { childList: true });
    return true;
  };

  const hosts = () => Array.from(document.querySelectorAll('shopify-forms-embed'));

  /* The embed attaches its shadow root after its own script loads, so poll briefly rather than
     assume it is there at DOMContentLoaded. */
  let attempts = 0;
  const timer = setInterval(() => {
    const pending = hosts().filter((host) => !host.dataset.orlWatched);

    pending.forEach((host) => {
      if (watch(host)) host.dataset.orlWatched = 'true';
    });

    attempts += 1;
    if ((hosts().length && !pending.length) || attempts > 100) clearInterval(timer);
  }, 100);
})();
